import { useGetSubscription } from "./useGetSubscription"

const MAX_DEFAULT_CREDITS = 50

export function useSubscriptionData() {
  const { data, isPending } = useGetSubscription()
  const {
    subscription,
    creditPackages,
    subscriptionCreditsRemaining,
    packageCreditsRemaining,
    autoTopUpPriceId,
  } = data ?? {}

  const hasSubscription = Boolean(subscription?.id)

  const totalSubscriptionCredits = subscription?.credits ?? MAX_DEFAULT_CREDITS
  const remainingSubscriptionCredits = subscriptionCreditsRemaining ?? 0
  const usedSubscriptionCredits = Math.max(
    totalSubscriptionCredits - remainingSubscriptionCredits,
    0,
  )
  const subscriptionRenewalDate =
    subscription?.autoRenew && subscription?.currentPeriodEnd
      ? new Date(subscription.currentPeriodEnd)
      : undefined

  const activeAddon = creditPackages?.active.at(0)
  const hasAddon = activeAddon !== undefined
  const showAddonOnPreview = hasAddon && remainingSubscriptionCredits <= 0
  const totalAddonCredits =
    creditPackages?.active.reduce((acc, addon) => acc + addon.credits, 0) ?? 0
  const remainingAddonCredits = activeAddon?.remaining ?? 0
  const usedAddonCredits = Math.max(totalAddonCredits - (packageCreditsRemaining ?? 0), 0)

  // If the remaining addon credits are less than 10% of the total addon credits, we consider it an error
  const addonIsError = hasAddon && (packageCreditsRemaining ?? 0) <= totalAddonCredits * 0.1

  // If the remaining credits are less than 10% of the total credits, we consider it an error
  const subscriptionIsError =
    !hasAddon && remainingSubscriptionCredits <= totalSubscriptionCredits * 0.1

  return {
    isPending,
    hasSubscription,
    totalSubscriptionCredits,
    remainingSubscriptionCredits,
    usedSubscriptionCredits,
    subscriptionRenewalDate,
    subscriptionIsError,
    hasAddon,
    showAddonOnPreview,
    totalAddonCredits,
    remainingAddonCredits,
    usedAddonCredits,
    addonIsError,
    autoTopUpPriceId,
    activeSubscriptionName: subscription?.name ?? "none",
  }
}
